import { imagenes } from './site'

export type ServicioVariante = 'roja' | 'blanca' | 'negra'

export interface Servicio {
  id: string
  variante: ServicioVariante
  pregunta: string
  titulo: string
  texto: string
  cta: { label: string; tipo: 'llamada' | 'whatsapp' }
  imagen: { src: string; alt: string }
  ladoImagen: 'izquierda' | 'derecha'
}

export const servicios: Servicio[] = [
  {
    id: 'magia-roja',
    variante: 'roja',
    pregunta: '¿Deseas recuperar la conexión con tu pareja?',
    titulo: 'MAGIA ROJA PODEROSA',
    texto:
      'A través de rituales, conjuros y hechizos ancestrales, nuestro experto en Magia Roja te acompaña paso a paso en tu proceso para atraer y fortalecer la conexión con esa persona especial.',
    cta: { label: 'COMUNICATE AHORA', tipo: 'llamada' },
    imagen: {
      src: imagenes.altarRojo,
      alt: 'Mesa de altar con velas rojas, frascos de hierbas y pétalos de rosa',
    },
    ladoImagen: 'derecha',
  },
  {
    id: 'magia-blanca',
    variante: 'blanca',
    pregunta: '¿Buscas protección espiritual y armonía en tu vida diaria?',
    titulo: 'MAGIA BLANCA PODEROSA',
    texto:
      'A través de nuestros rituales y conjuros, trabajamos para traer equilibrio a distintas áreas de tu vida: sanación espiritual, protección energética, limpieza de energías negativas y apertura de caminos hacia la prosperidad.',
    cta: { label: 'ESCRIBE A WHATSAPP', tipo: 'whatsapp' },
    imagen: {
      src: imagenes.tarotBlanco,
      alt: 'Cartas de tarot y cristales de cuarzo sobre tela blanca',
    },
    ladoImagen: 'izquierda',
  },
  {
    id: 'magia-negra',
    variante: 'negra',
    pregunta: '¿Buscas distanciar una relación o cerrar un ciclo?',
    titulo: 'MAGIA NEGRA PODEROSA',
    texto:
      'Contamos con brujos especializados en trabajos de magia negra: alejamientos, cierre de ciclos, trabajos espirituales relacionados con la Santa Muerte, y rituales de unión para todo tipo de parejas.',
    cta: { label: 'COMUNICATE AHORA', tipo: 'llamada' },
    imagen: {
      src: imagenes.santaMuerte,
      alt: 'Figura encapuchada de la Santa Muerte rodeada de velas encendidas',
    },
    ladoImagen: 'derecha',
  },
]
